export default __webpack_public_path__ + "assets/01_App.png";